if(window.location.pathname.indexOf('product')>0){

window.addEventListener('DOMContentLoaded', (event) => {
  const hiddenInput = document.querySelector('[name="id"]')
  let previousValue = hiddenInput.value;
  const observer = new MutationObserver((mutations) => {
    // 2: iterate over MutationRecord array
    mutations.forEach(mutation => {
      // 3.1: check if the mutation type and the attribute name match
      // 3.2: check if value changed
      if (
        mutation.type === 'attributes'
        && mutation.attributeName === 'value'
        && hiddenInput.value !== previousValue
      ) {
        previousValue = hiddenInput.value;
        // 3.4: trigger change event
        hiddenInput.dispatchEvent(new Event('change'));
      }
    });
  });
  // 4: observe changes on hiddenInput
  observer.observe(hiddenInput, { attributes: true });
  const input = document.querySelector('[name="id"]')
  const box = input.closest('.pf-product-form')
  const id = input.getAttribute('data-product-id')
  const data = __pageflyProducts[id]
  const ls = box.querySelectorAll('[data-pf-type="ProductVariantSwatches"] [data-pf-type="OptionLabel"]')
  console.log('ls',ls)
  data.options_with_values.forEach((el, i) => {
    if (el.name == ls[i].innerText) {
      const sl = document.createElement('div')
      sl.className = "variant_selected";
      sl.setAttribute('data-value', el.values)
      sl.style.fontWeight='700';
      ls[i].appendChild(sl)
      ls[i].classList.add('custom_variant')
    }
  })
  const handle = (e) => {
    const value = e.value;
    let activeV = data.variants.filter(v => v.id == value)
    activeV = activeV[0]
    box.querySelectorAll('[data-value]').forEach((el, i) => {
      const data = el.getAttribute('data-value')
      activeV.options.forEach(vel => {
        if (data.indexOf(vel) >= 0) {
          console.log('label', ls[i])
          ls[i].querySelector('.variant_selected').innerText = ` : ${vel}`
        }
      })
    })
  }
  handle(input)
  input.onchange = (e) => handle(e.target)
	  const style = document.createElement('style');
	  style.innerHTML = `
	.custom_variant {
	  display: flex !important;
	  gap: 5px
	}
	`
	  document.body.appendChild(style)
});

}